import React, { useCallback, useState } from 'react'
import { Layout } from '~/layouts/default'
import Header from '~/components/business/RankHeader'
import { RankTabs } from '~/components/business/RankTabs'
import { CreatorsList } from '~/components/pages/rank/CreatorsList'
import { GET_ART_TRADE_RANK } from '~/graphqls/gqls'
import { QueryDateEnum } from '~/graphqls/types/gqls.global'
import { getGraphData } from '~/utils'
import {
  getArtTradeRank_copyrightStatisticsModule_creatorsList_edges_node,
  getArtTradeRank,
  getArtTradeRankVariables,
} from '~/graphqls/types/getArtTradeRank'
import { MyEmpty } from '~/components/ui/MyEmpty'
import type { GetServerSideProps, NextPage } from 'next'
import { GlobalRequest } from '~/components/global-requset'
import { useDidUpdateEffect } from '~/hooks/useDidUpdateEffect'
import { TabsItemProps } from '~/components/pages/rank/hooks'
import {
  useCreators,
  creatorTabList,
  creatorsTimeTabsData,
  CREATORS_TAB_TYPE,
} from '~/components/pages/rank/hooks/useCreators'
import { RANK_PAGE_SIZE } from '~/configs'
import { StyledRankContent } from './collections'

const Creators: NextPage<{
  creatorList: getArtTradeRank_copyrightStatisticsModule_creatorsList_edges_node[]
}> = ({ creatorList = [] }) => {
  const [sortType, setSortType] = useState<string>('TRADE_MONEY')

  const [timeSortType, setTimeSortType] = useState<QueryDateEnum>(
    QueryDateEnum.THIRTY_DAYS
  )
  const [rankList, setRankList] =
    useState<
      getArtTradeRank_copyrightStatisticsModule_creatorsList_edges_node[]
    >(creatorList)

  const { getTradeRankList, getNewRankList, getFansRankList } = useCreators()

  const onClassifyChange = useCallback(
    (params: TabsItemProps) => {
      setSortType(params.key)
    },
    [sortType]
  )

  const onTimeChange = useCallback(
    (params: TabsItemProps) => {
      setTimeSortType(params.key as QueryDateEnum)
    },
    [timeSortType]
  )
  const fetchData = useCallback(async () => {
    let res: any = {}
    const params: getArtTradeRankVariables = {
      first: RANK_PAGE_SIZE,
      offset: 0,
      date: timeSortType,
    }
    if (sortType === CREATORS_TAB_TYPE.TRADE_MONEY) {
      res = await getTradeRankList(params)
    } else if (sortType === CREATORS_TAB_TYPE.LIKE_COUNT) {
      params.date = QueryDateEnum.ALL_TIME
      res = await getFansRankList(params)
    } else {
      params.date = QueryDateEnum.THIRTY_DAYS
      res = await getNewRankList(params)
    }
    setRankList(
      getGraphData(
        res.data?.copyrightStatisticsModule?.creatorsList?.edges || []
      )
    )
  }, [sortType, timeSortType])
  useDidUpdateEffect(() => {
    fetchData()
  }, [sortType, timeSortType])
  return (
    <Layout>
      <div className="bg-neutral-700 pb-4 -mb-10">
        <Header />
        <StyledRankContent>
          <div className="flex">
            <RankTabs
              data={creatorTabList}
              onChange={onClassifyChange}
              defaultValue={CREATORS_TAB_TYPE.TRADE_MONEY}
            />
            {sortType === CREATORS_TAB_TYPE.TRADE_MONEY && (
              <RankTabs
                style={{ marginLeft: 24 }}
                data={creatorsTimeTabsData}
                onChange={onTimeChange}
                defaultValue={timeSortType}
              />
            )}
          </div>
          {rankList.length ? <CreatorsList data={rankList} /> : <MyEmpty />}
        </StyledRankContent>
      </div>
    </Layout>
  )
}

export const getServerSideProps: GetServerSideProps = async context => {
  const { initialState, client } = await GlobalRequest(context)

  const res = await client.query<getArtTradeRank, getArtTradeRankVariables>({
    query: GET_ART_TRADE_RANK,
    fetchPolicy: 'no-cache',
    variables: {
      first: RANK_PAGE_SIZE,
      offset: 0,
      date: QueryDateEnum.THIRTY_DAYS,
    },
  })
  return {
    props: {
      initialState,
      creatorList: getGraphData(
        res.data?.copyrightStatisticsModule?.creatorsList?.edges || []
      ),
    },
  }
}

export default Creators
